import { render, staticRenderFns } from "./RPProfile.vue?vue&type=template&id=5892b20f&"
import script from "./RPProfile.vue?vue&type=script&lang=js&"
export * from "./RPProfile.vue?vue&type=script&lang=js&"
import style0 from "./RPProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports